// extracted by mini-css-extract-plugin
module.exports = {"Book":"BrandStory_Book__nRKzw","BookWrapper":"BrandStory_BookWrapper__HUzcl"};